import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import styles from "./videoscreen.module.scss";
import VideoSmall from '../webChatScreen/videoWidgets/videoSmall';
import store from '../../store/redux-store/root_store';
import _ from 'lodash';
import { formatTime, setRecTimer, sipCallEnd, updateCCLang, iterateSoreChat, stopScreenSharing, formatTransferTimer } from '../../base/video_common';

import { videoCallService } from '../../base/service/videoCallService';
import { deviceState, initialStateModel } from '../../base/models/meetModal';
import { video_disable, meetService } from '../../services/meetService';
import CloseCaptionCommon from './closeCaption/closecaption';
import { useDispatch, useSelector } from 'react-redux';

import VideoMeetingChat from './meetChat';
import { actionTypes, meetActionTypes } from '../../base/action/action';
import VideoShareLeftBar from './videoleftbar';
import MeetTranscription from './meetTranscription/index';
import audion from "../../styles/images/audion.svg";
import audioh from "../../styles/images/audioh.svg";
import audioa from "../../styles/images/audioa.svg";

import videon from "../../styles/images/videon.svg";
import videoh from "../../styles/images/videoh.svg";
import videoa from "../../styles/images/videoa.svg";

import chatn from "../../styles/images/chatn.svg";
import chath from "../../styles/images/chath.svg";
import chata from "../../styles/images/chata.svg";
import chatd from "../../styles/images/chatd.svg";

import ccn from "../../styles/images/ccn.svg";
import cch from "../../styles/images/cch.svg";
import cca from "../../styles/images/cca.svg";
import { Button, Modal, Popover, notification, Tooltip } from 'antd';
import { checkShareStatus, setRemoteVideo,drawLineCustomer } from '../../annotation';
import { elements } from 'chart.js';
import sharingReducerState from '../../base/reducer/screenShareReducer';
import { GetItemFromStorage } from '../../custom_hooks/useStorage';


export default function VideoMeetingCustomer() {
  const { activeParticipantList, currdeviceinfo, recordAllowed, elapsedTime,vmTransfer, recTimer, pauseTime,customerComponentState,vmTransferTimer,videoCallDetails } = store.getState().meetingReducer;
  const { sharingStatus, conId,annotation,annotationEnable,annotationPopup } = store.getState().sharingReducerState;
  const { closeCaptionText, ccBtns,ccLang } = store.getState().closeCaption;
  const [meetControlWindow, setmeetControlWindow] = useState<any>({
    chatWindow: true
  })
  const {chatConvo}:any=store.getState().messageReducer;
  const [endModal, setEndModal] = useState(false);
  let dispatch: any = useDispatch();
  let stored_Video = store.getState().storeVideo;

  let activeSpeaker = store.getState().meetingReducer;
  let activeSpeakerState: any = activeSpeaker || {}
  let participantVideo: any = useRef(null);
  let screenShareVideo: any = useRef(null);
  let remVideo: any = useRef(null);
  const [lang, setLang] = useState(['Global English (en) - default', 'Spanish (es)',
    'French (fr)', 'Portuguese (pt)', 'Japanese (ja)', 'Korean (ko)', 'Tamil (ta)', 'Telugu (te)', 'Hindi (hi)', 'Arabic (ar)', 'Bengali (bn)', 'Russian (ru)', 'Polish (pl)', 'Romanian (ro)', 'Urdu (ur)'])
  let remotedev: any = activeParticipantList.filter((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare"))})
  let screensharedetails: any = activeParticipantList.filter((ele: any) => { return conId === ele.conId + "_screenshare" })
  const [switchStream, setSwitchStream] = useState<any>(false);
  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  const { toParticipant } = videoMeetState.messageReducer;
  const meetingDetails: any = store.getState().meetingReducer || {};
  const [count,setCount]=useState(0);
  let publicChat = 0;

  useEffect(() => {

  }, [recordAllowed, elapsedTime, recTimer, pauseTime,customerComponentState])

  const switchVideoStream = () => {
    setSwitchStream(!switchStream);
  }



  useEffect(() => {
    if (currdeviceinfo.status === "joined") {
      let videoData: any = _.find(stored_Video.participantList, { participants: currdeviceinfo.conId });
      if (videoData !== undefined && videoData.stream !== '' && participantVideo.current) {
        if ((participantVideo.current.srcObject === null)
          || (participantVideo.current.srcObject.id !== videoData.stream.id)) {
          participantVideo.current.srcObject = videoData.stream;
        }
      }


    }
    if (remotedev[0]?.status === "joined") {
      let videoData: any = _.find(stored_Video.participantList, { participants: remotedev[0]?.conId });
      if (videoData !== undefined && videoData.stream !== '' && remVideo.current) {
        if ((remVideo.current.srcObject === null)
          || (remVideo.current.srcObject.id !== videoData.stream.id)) {
          remVideo.current.srcObject = videoData.stream;
        }
      }
    }
    if(customerComponentState!=="customerChat"){
      setCount(0)}
  }, [activeSpeakerState, activeParticipantList, stored_Video, activeParticipantList.length,customerComponentState])

  useEffect(() => {

  }, [closeCaptionText[closeCaptionText?.length - 1]?.length, closeCaptionText?.length,vmTransfer])


  useEffect(() => {
    const { participantList } = store.getState().storeVideo;
    const isScreenShare: any = store.getState().sharingReducerState || [];
    let videoData: any = _.find(participantList, { participants: isScreenShare.conId });
    console.log("videoData >>>>>>>", videoData);
    if (sharingStatus && videoData !== undefined && videoData.stream !== "") {
      if ((screenShareVideo && screenShareVideo.current && screenShareVideo.current.srcObject === null)
        || (screenShareVideo.current.srcObject.id !== videoData.stream.id)) {
        screenShareVideo.current.srcObject = videoData.stream;
        screenShareVideo.current.muted = true;
        console.log("screenShareVideo >>>>>>>>", screenShareVideo);
      }

    }
  }, [sharingStatus, stored_Video, stored_Video.participantList.length]);

  const muteAudio = () => {
    const { currdeviceinfo } = store.getState().meetingReducer;
    let mediaDeviceInfo: deviceState = store.getState().mediaDevice;


    if (mediaDeviceInfo.isAudio) {

      let input: any = {};
      input.socketId = currdeviceinfo["conId"];
      input.mute = !currdeviceinfo.mute;
      videoCallService.audioStatus(input);

    } else {
      //   toastStatus(mediaDeviceInfo.isAudioStatus);
      notification.info({
        message: `${mediaDeviceInfo.isAudioStatus}`,
        placement: "top",
        className: "toastNotification success",
        icon: <span className="icon__Success24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
    }
  };

  const startCloseCaption = () => {

    let input: any = {};
    input.socketId = currdeviceinfo['conId'];

    if (!ccBtns) {
      videoCallService.startCloseCaption(input);
    }
    else {
      try {
        let stopinput: any = {};
        stopinput.socketId = currdeviceinfo['conId'];
        videoCallService.stopCloseCaption(stopinput);
      }
      catch (e: any) {
        console.log("error");
      }
    }
  }

  const muteVideo = () => {
    const { currdeviceinfo } = store.getState().meetingReducer;
    let mediaDeviceInfo: deviceState = store.getState().mediaDevice;
    console.log("mediaDeviceInfo+++++++++++",mediaDeviceInfo);
    if (mediaDeviceInfo.isVideo) {
      let input: any = {};
      input.socketId = currdeviceinfo['conId'];
      input.video = !currdeviceinfo.video;
      if (currdeviceinfo.video) { video_disable(input); }
      else { new meetService(dispatch).sendRe_invite(input); }
    }
    else {
      notification.info({
        message: `${mediaDeviceInfo.isVideoStatus}`,
        placement: "top",
        className: "toastNotification success",
        icon: <span className="icon__Success24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
    }
  };

  const end = () => {
    setEndModal(true);
  }

  const endall = () => {
    console.log("end call func trigger==");
    setEndModal(false);
    sipCallEnd();
    videoCallService.endMeeting('endall');
  }
  const continueRecording = () => {
    const {activeParticipantList,currdeviceinfo}:any=store.getState().meetingReducer;
    let remotedev: any = activeParticipantList.filter((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare"))})
    videoCallService.recordingAction("start",remotedev[0].conId)
    notification.info({
      message: `This video is being recorded`,
      placement: "top",
      className: "toastNotification success",
      icon: <span className="icon__Success24" />,
      closeIcon: <span className="icon__IconCloseNew16" />,
      duration: 3,
      top: 70,
    });
    store.dispatch({
      type: meetActionTypes.RECORD_UPDATE,
      payload: {
        recordAllowed: false
      }
    })
  }

  useEffect(() => {
    let timerInterval: any;

    if (remotedev[0]?.recordingStatus === "start" || remotedev[0]?.recordingStatus === "resume") {
      timerInterval = setInterval(() => {
        const currentTime = Date.now();
        const totalElapsedTime = (currentTime - recTimer);
        setRecTimer(recTimer, pauseTime, totalElapsedTime)
      }, 1000);
    }

    let timerIntervalTransfer: any;

    if (vmTransfer) {
      timerIntervalTransfer = setInterval(() => {
        let {vmTransferStartTime}:any=store.getState().meetingReducer;
        const now = new Date();
        store.dispatch({
          type:meetActionTypes.VM_TRANSFER_TIME,
         payload:{
          vmTransferTimer:now.getTime()-vmTransferStartTime,
          vmTransferStartTime:vmTransferStartTime
        }
        })
      }, 1000);
    }
    else{
      clearInterval(timerIntervalTransfer);
    }

    return () => {clearInterval(timerInterval);
                clearInterval(timerIntervalTransfer);}
  }, [remotedev[0]?.recordingStatus, elapsedTime, recTimer,vmTransfer]);

  const meetChat = () => {

    let { chatWindow } = meetControlWindow;


    store.dispatch({
      type: meetActionTypes.CUSTOMER_CONTROL_OPEN,
      payload: {
        customerComponentState: "customerChat"
      }
    })

    iterateSoreChat(toParticipant);
    setCount(0);
  }

  const updateCCLanguageSelection = (lang: any, language: any) => {
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    let input: any = {};
    input.socketId = currdeviceinfo['conId'];
    input.lang = lang;
    updateCCLang(lang);
    videoCallService.updateLang(input);
    notification.info({
      message: `CC changed to ${language}`,
      placement: "top",
      className: "toastNotification success",
      icon: <span className="icon__Success24" />,
      closeIcon: <span className="icon__IconCloseNew16" />,
      duration: 3,
      top: 70,
    });
  }

  const closeEndModal = () => {
    setEndModal(false);
  }

  const closeRecordModal = () => {
    store.dispatch({
      type: meetActionTypes.RECORD_UPDATE,
      payload: {
        recordAllowed: false
      }
    })
  }

  const content = (
    <div className="moreoptionpop">
      <div className="profileAreaPopover">
        <div className="userDetails">
          <span className="langTitle">CC Languages</span>
          <ul className="scroller langSelection">
            {lang.includes('Global English (en) - default') && <li onClick={() => updateCCLanguageSelection('en', "English")}><span className="title1">English</span></li>}
            {lang.includes('Arabic (ar)') && <li onClick={() => updateCCLanguageSelection('ar', "Arabic")}><span className="title1">Arabic</span></li>}
            {lang.includes('Bengali (bn)') && <li onClick={() => updateCCLanguageSelection('bn', "Bengali")}><span className="title1">Bengali</span></li>}
            {lang.includes('French (fr)') && <li onClick={() => updateCCLanguageSelection('fr', "French")}><span className="title1">French</span></li>}
            {lang.includes('Hindi (hi)') && <li onClick={() => updateCCLanguageSelection('hi', "Hindi")}><span className="title1">Hindi</span></li>}
            {lang.includes('Japanese (ja)') && <li onClick={() => updateCCLanguageSelection('ja', "Japanese")}><span className="title1">Japanese</span></li>}
            {lang.includes('Korean (ko)') && <li onClick={() => updateCCLanguageSelection('ko', "Korean")}><span className="title1">Korean</span></li>}
            {lang.includes('Polish (pl)') && <li onClick={() => updateCCLanguageSelection('pl', "Polish")}><span className="title1">Polish</span></li>}
            {lang.includes('Portuguese (pt)') && <li onClick={() => updateCCLanguageSelection('pt', "Portuguese")}><span className="title1">Portuguese</span></li>}
            {lang.includes('Romanian (ro)') && <li onClick={() => updateCCLanguageSelection('ro', "Romanian")}><span className="title1">Romanian</span></li>}
            {lang.includes('Russian (ru)') && <li onClick={() => updateCCLanguageSelection('ru', "Russian")}><span className="title1">Russian</span></li>}
            {lang.includes('Spanish (es)') && <li onClick={() => updateCCLanguageSelection('es', "Spanish")}><span className="title1">Spanish</span></li>}
            {lang.includes('Tamil (ta)') && <li onClick={() => updateCCLanguageSelection('ta', "Tamil")}><span className="title1">Tamil</span></li>}
            {lang.includes('Telugu (te)') && <li onClick={() => updateCCLanguageSelection('te', "Telugu")}><span className="title1">Telugu</span></li>}
            {lang.includes('Urdu (ur)') && <li onClick={() => updateCCLanguageSelection('ur', "Urdu")}><span className="title1">Urdu</span></li>}

          </ul>
        </div>
      </div>
    </div>
  );

  const backToReset = () => {
      let { currdeviceinfo } = store.getState().meetingReducer || [];
      let input: any = {};
      input.socketId = currdeviceinfo['conId'];
      input.lang = "en";
      updateCCLang(lang);
      videoCallService.updateLang(input);
  }

  const openTranscription = () => {
    store.dispatch({
      type: meetActionTypes.CUSTOMER_CONTROL_OPEN,
      payload: {
        customerComponentState: "customertranscription"
      }
    })
  }

  useLayoutEffect(()=>{
    const remoteVideo:any = document.getElementById('screenShareVideo');
  if(remoteVideo){  
    setRemoteVideo(remoteVideo.offsetWidth,remoteVideo.offsetHeight);
    // sendScreenSize();
  }
  const chatStore = GetItemFromStorage("chat") || "";
  if (chatStore) {
    const parseChat: any = JSON.parse(chatStore);
    if (meetingDetails?.meetingDetails?.uuid && parseChat && parseChat[meetingDetails.meetingDetails.uuid] && parseChat[meetingDetails.meetingDetails.uuid]["private"] !== undefined) {
      Object.values(parseChat[meetingDetails.meetingDetails.uuid]["private"]).map((value: any) => {
        publicChat = publicChat + value.count;
        setCount(publicChat);    
        return value;
      });
    }

  }

  },[screenShareVideo?.offsetHeight,screenShareVideo?.offsetWidth,annotation?.length,JSON.stringify(sharingReducerState),screenShareVideo,annotationEnable,annotationPopup,chatConvo?.length,JSON.stringify(chatConvo),count])

  const sendScreenSize=()=>{
    console.log("resizeeeee")
    let canvasAgent:any= document.getElementById("canvaagent");
    if(canvasAgent){
      let mainBoard:any=document.getElementById('screenShareVideo');
    canvasAgent.height=mainBoard?.offsetHeight;
    canvasAgent.width=mainBoard?.offsetWidth;
    let data:any={};
    data.width=mainBoard.offsetWidth;
    data.height=mainBoard.offsetHeight;
    data.conId=remotedev[0]?.conId;
    data.deviceid=remotedev[0]?.deviceid;
    videoCallService.updateScreenSize(data)
    drawLineCustomer(annotation);
    }
  }

  const decline=()=>{
    let data:any={
      conId:currdeviceinfo.conId,
      deviceid:currdeviceinfo.deviceid
     }
   videoCallService.declineCoBrowsing(data)
  }
  const accept=()=>{
    store.dispatch({type:actionTypes.ANNOTATION_STATUS,
      payloads:{
      annotationEnable:true,annotationPopup:false
     }})
     let data:any={
      conId:currdeviceinfo.conId,
      deviceid:currdeviceinfo.deviceid
     }
     let {annotationEnable}=store.getState().sharingReducerState;
     videoCallService.acceptCoBrowsing(data);
     onshareScreen();
  }

  const onshareScreen = () => {

    let check = checkShareStatus();
    if (check.status) {
      new meetService(dispatch).startSharing()
    } else {
      notification.info({
        message: check.error,
        placement: "top",
        className: "toastNotification success",
        icon: <span className="icon__Success24" />,
        closeIcon: <span className="icon__IconCloseNew16" />,
        duration: 3,
        top: 70,
      });
    }
 
}
  const closeCobrowser=()=>{
    store.dispatch({type:actionTypes.ANNOTATION_STATUS,payloads:{
      annotationEnable:false,annotationPopup:false
     }})
  }


  const cccontent = (
    <div className="moreoptionpop">
      <div className="profileAreaPopover">
        <div className="userDetails">
          <ul className="langSelection langnoscroll">
            <li>Close captions
              <span>
                <Popover content={content} placement="rightBottom"
                  trigger="click"
                  overlayClassName="morecochat"
                >{ccLang === "ar" ? "Arabic" : ccLang === "bn" ? "Bengali" : ccLang === "en" ? "English" : ccLang === "fr" ? "French" : ccLang === "hi" ? "Hindi" : ccLang === "ja" ? "Japanese" : ccLang === "ko" ? "Korean" : ccLang === "pl" ? "Polish" : ccLang === "pt" ? "Portuguese" : ccLang === "ro" ? "Romanian" : ccLang === "ru" ? "Russian" : ccLang === "es" ? "Spanish" : ccLang === "ta" ? "Tamil" : ccLang === "te" ? "Telugu" : ccLang === "ur" ? "Urdu" : "English"}
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
                    <path d="M0.847119 11.6649C0.654719 11.6649 0.462319 11.5917 0.315919 11.4442C0.0234195 11.1512 0.0244193 10.6766 0.317919 10.3837L4.18222 6.53116C4.32432 6.38956 4.40242 6.20006 4.40242 5.99896C4.40242 5.79876 4.32432 5.61026 4.18222 5.46866L0.31752 1.61516C0.0245197 1.32216 0.0236196 0.84756 0.31602 0.55466C0.60802 0.26076 1.08312 0.26076 1.37702 0.55266L5.24132 4.40616C5.66712 4.83096 5.90192 5.39636 5.90242 5.99896C5.90292 6.60156 5.66802 7.16696 5.24132 7.59366L1.37662 11.4462C1.23062 11.5917 1.03852 11.6649 0.847119 11.6649Z" fill="#000" />
                  </svg>
                </Popover>
              </span>
            </li>
            <li style={{ color: "#575CFF" }} onClick={backToReset}>Reset to default</li>
            <li onClick={openTranscription}>View Transcript</li>
          </ul>
        </div>
      </div>
    </div>
  );

  const stopShare = () => {
    stopScreenSharing();
  }

  let mainBoard:any=document.getElementById('screenShareVideo');
  let canvasHeight:any=mainBoard?.offsetHeight;
  let canvasWidth:any=mainBoard?.offsetWidth;

  return (
    <>

      <div className={styles.videomaindiv}>
      
        {sharingStatus && <div className="sharescreeninfomain">
          <div className="sharescreeninfo">
            <div className="sharescreenleft">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.0191 3.00891C2.8417 3.00891 3.51477 2.33584 3.51477 1.51324C3.51477 0.690645 2.8417 0.0175781 2.0191 0.0175781C1.1965 0.0175781 0.523438 0.690645 0.523438 1.51324C0.523438 2.33584 1.1965 3.00891 2.0191 3.00891ZM2.0191 4.50458C1.1965 4.50458 0.523438 5.17764 0.523438 6.00025C0.523438 6.82284 1.1965 7.49591 2.0191 7.49591C2.8417 7.49591 3.51477 6.82284 3.51477 6.00025C3.51477 5.17764 2.8417 4.50458 2.0191 4.50458ZM0.523438 10.4872C0.523438 9.66464 1.1965 8.99158 2.0191 8.99158C2.8417 8.99158 3.51477 9.66464 3.51477 10.4872C3.51477 11.3098 2.8417 11.9829 2.0191 11.9829C1.1965 11.9829 0.523438 11.3098 0.523438 10.4872Z" fill="black" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.98137 3.00891C7.80397 3.00891 8.47704 2.33584 8.47704 1.51324C8.47704 0.690645 7.80397 0.0175781 6.98137 0.0175781C6.15877 0.0175781 5.4857 0.690645 5.4857 1.51324C5.4857 2.33584 6.15877 3.00891 6.98137 3.00891ZM6.98137 4.50458C6.15877 4.50458 5.4857 5.17764 5.4857 6.00025C5.4857 6.82284 6.15877 7.49591 6.98137 7.49591C7.80397 7.49591 8.47704 6.82284 8.47704 6.00025C8.47704 5.17764 7.80397 4.50458 6.98137 4.50458ZM5.4857 10.4872C5.4857 9.66464 6.15877 8.99158 6.98137 8.99158C7.80397 8.99158 8.47704 9.66464 8.47704 10.4872C8.47704 11.3098 7.80397 11.9829 6.98137 11.9829C6.15877 11.9829 5.4857 11.3098 5.4857 10.4872Z" fill="black" />
              </svg>
              {!annotationEnable? `${screensharedetails[0]?.name} is sharing screen` : `${remotedev[0]?.name} (Agent) controls your screen`}
              <svg xmlns="http://www.w3.org/2000/svg" width="3" height="12" viewBox="0 0 3 12" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.50006 3.00891C2.32266 3.00891 2.99573 2.33584 2.99573 1.51324C2.99573 0.690645 2.32266 0.0175781 1.50006 0.0175781C0.677461 0.0175781 0.00439453 0.690645 0.00439453 1.51324C0.00439453 2.33584 0.677461 3.00891 1.50006 3.00891ZM1.50006 4.50458C0.677461 4.50458 0.00439453 5.17764 0.00439453 6.00024C0.00439453 6.82284 0.677461 7.49591 1.50006 7.49591C2.32266 7.49591 2.99573 6.82284 2.99573 6.00024C2.99573 5.17764 2.32266 4.50458 1.50006 4.50458ZM0.00439453 10.4872C0.00439453 9.66464 0.677461 8.99158 1.50006 8.99158C2.32266 8.99158 2.99573 9.66464 2.99573 10.4872C2.99573 11.3098 2.32266 11.9829 1.50006 11.9829C0.677461 11.9829 0.00439453 11.3098 0.00439453 10.4872Z" fill="black" />
              </svg>
            </div>
            {annotationEnable && <div className="sharescreenright" onClick={stopShare}>
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M1.16413 0.671875C0.611964 0.671875 0.164551 1.11929 0.164551 1.67146V10.328C0.164551 10.8798 0.611964 11.3276 1.16413 11.3276C1.7163 11.3276 2.16372 10.8798 2.16372 10.328V1.67146C2.16372 1.11929 1.7163 0.671875 1.16413 0.671875Z" fill="white" />
                <path d="M5.83539 0.671875C5.28355 0.671875 4.8358 1.11929 4.8358 1.67146V10.328C4.8358 10.8798 5.28355 11.3276 5.83539 11.3276C6.38723 11.3276 6.83497 10.8798 6.83497 10.328V1.67146C6.83497 1.11929 6.38723 0.671875 5.83539 0.671875Z" fill="white" />
              </svg>
              Stop Co-browsing
            </div>}
          </div>
        </div>}
        {!sharingStatus ? (
          <div className={styles.videosection}>
            <div className={styles.videoleft} style={{ width: customerComponentState === "" ? "100%" : "calc(100% - 368px)" }}>
                {ccBtns && !sharingStatus && <CloseCaptionCommon type={"customer"+ styles.agentcaptions} />}
              <div className={styles.videotopbar}>
                <div className={styles.lefts}>
                  <ul>
                    <li>
                      {!remotedev[0]?.mute ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="8" fill="black" fill-opacity="0.2" />
                        <g clip-path="url(#clip0_3269_55899)">
                          <path d="M16 19.2655C17.7148 19.2655 19.1104 17.87 19.1104 16.1551V9.58475C19.1104 7.86995 17.7149 6.47485 16 6.47485C14.2851 6.47485 12.8901 7.86985 12.8901 9.58475V16.1551C12.8901 17.8699 14.2851 19.2655 16 19.2655ZM14.3901 9.58475C14.3901 8.69705 15.1123 7.97485 16 7.97485C16.8882 7.97485 17.6104 8.69705 17.6104 9.58475V16.1551C17.6104 17.0433 16.8882 17.7655 16 17.7655C15.1123 17.7655 14.3901 17.0433 14.3901 16.1551V9.58475Z" fill="#000" />
                          <path d="M22.4404 16.055V13.0447C22.4404 12.6306 22.1045 12.2947 21.6904 12.2947C21.2763 12.2947 20.9404 12.6306 20.9404 13.0447V16.055C20.9404 18.6629 18.7246 20.785 16 20.785C13.2754 20.785 11.0601 18.6629 11.0601 16.055V13.0447C11.0601 12.6306 10.7242 12.2947 10.3101 12.2947C9.89596 12.2947 9.56006 12.6306 9.56006 13.0447V16.055C9.56006 19.2443 12.0518 21.8779 15.25 22.239V24.2244H11.8301C11.4712 24.2244 11.1802 24.5154 11.1802 24.8748C11.1802 25.2342 11.4712 25.5252 11.8301 25.5252H20.1699C20.5293 25.5252 20.8203 25.2342 20.8203 24.8748C20.8203 24.5154 20.5293 24.2244 20.1699 24.2244H16.75V22.239C19.9483 21.8779 22.4404 19.2442 22.4404 16.055Z" fill="#000" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3269_55899">
                            <rect width="24" height="24" fill="white" transform="translate(4 4)" />
                          </clipPath>
                        </defs>
                      </svg> :


                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="28" height="28" rx="6" fill="black" fill-opacity="0.2" />
                          <g clip-path="url(#clip0_3269_6851)">
                            <path d="M12.39 9.96498L15.61 13.195L16.36 13.955L17.07 14.665C17.1 14.495 17.11 14.325 17.11 14.155V7.58498C17.11 5.86498 15.71 4.47498 14 4.47498C12.28 4.47498 10.89 5.86498 10.89 7.58498V8.45498L11.64 9.20498L12.39 9.96498Z" fill="#DE003D" />
                            <path d="M20.44 14.055V11.045C20.44 10.625 20.1 10.295 19.69 10.295C19.28 10.295 18.94 10.625 18.94 11.045V14.055C18.94 14.775 18.77 15.455 18.46 16.065L19.56 17.175C20.12 16.255 20.44 15.195 20.44 14.055Z" fill="#DE003D" />
                            <path d="M22.68 22.775C22.53 22.925 22.34 22.995 22.15 22.995C21.96 22.995 21.77 22.925 21.62 22.775L17.87 19.015C16.98 19.675 15.92 20.115 14.75 20.245V22.225H18.18C18.54 22.225 18.83 22.515 18.83 22.875C18.83 23.235 18.54 23.525 18.18 23.525H9.83004C9.47004 23.525 9.18004 23.235 9.18004 22.875C9.18004 22.515 9.47004 22.225 9.83004 22.225H13.25V20.245C10.04 19.885 7.55004 17.245 7.55004 14.055V11.045C7.55004 10.625 7.89004 10.295 8.30004 10.295C8.71004 10.295 9.05004 10.625 9.05004 11.045V14.055C9.05004 16.665 11.27 18.785 14 18.785C15.04 18.785 16.01 18.475 16.81 17.945L15.65 16.775C15.17 17.085 14.61 17.255 14 17.255C12.28 17.255 10.89 15.865 10.89 14.155V11.995L5.32004 6.40498C5.03004 6.11498 5.03004 5.63498 5.32004 5.34498C5.61004 5.05498 6.09004 5.05498 6.38004 5.34498L22.68 21.715C22.97 22.005 22.97 22.485 22.68 22.775Z" fill="#DE003D" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3269_6851">
                              <rect x="2" y="2" width="24" height="24" rx="6" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      }
                      {/* <li><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M17.7261 0.0126953H13.9263C13.5122 0.0126953 13.1763 0.348595 13.1763 0.762695C13.1763 1.1768 13.5122 1.5127 13.9263 1.5127H17.4151L12.2964 6.6318C12.0034 6.9248 12.0034 7.3994 12.2964 7.6923C12.4429 7.8388 12.6348 7.912 12.8267 7.912C13.0186 7.912 13.2105 7.8388 13.357 7.6923L18.4761 2.5727V6.0624C18.4761 6.4765 18.812 6.8124 19.2261 6.8124C19.6402 6.8124 19.9761 6.4765 19.9761 6.0624V2.2626C19.9761 1.0224 18.9668 0.0126953 17.7261 0.0126953Z" />
                      <path d="M6.64351 12.3076L1.52441 17.4272V13.9375C1.52441 13.5234 1.18851 13.1875 0.774414 13.1875C0.360314 13.1875 0.0244141 13.5234 0.0244141 13.9375V17.7373C0.0244141 18.9775 1.03371 19.9873 2.27441 19.9873H6.07421C6.48831 19.9873 6.82421 19.6514 6.82421 19.2373C6.82421 18.8232 6.48831 18.4873 6.07421 18.4873H2.58541L7.70411 13.3682C7.99711 13.0752 7.99711 12.6006 7.70411 12.3077C7.41111 12.0148 6.93641 12.0146 6.64351 12.3076Z" />
                    </svg></li> */}
                    </li>
                    {remotedev[0]?.recordingStatus !== "stop" && <li className={styles.recmain}>
                      <div className={styles.rectop}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M6.99967 0.333984C3.31967 0.333984 0.333008 3.32065 0.333008 7.00065C0.333008 10.6807 3.31967 13.6673 6.99967 13.6673C10.6797 13.6673 13.6663 10.6807 13.6663 7.00065C13.6663 3.32065 10.6797 0.333984 6.99967 0.333984ZM6.99967 9.67398C5.52634 9.67398 4.33301 8.48065 4.33301 7.00732C4.33301 5.53398 5.52634 4.34065 6.99967 4.34065C8.47301 4.34065 9.66634 5.53398 9.66634 7.00732C9.66634 8.48065 8.47301 9.67398 6.99967 9.67398Z" fill="#DE003D" />
                        </svg>
                        Rec
                        <div>{formatTime(elapsedTime)}</div>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                  <path d="M9.02623 4.61023L5.80091 2.75101L2.57559 0.891783C2.31569 0.745178 2.04247 0.671875 1.77592 0.671875C0.936269 0.671875 0.169922 1.34493 0.169922 2.27787V9.72144C0.169922 10.661 0.936269 11.3274 1.77592 11.3274C2.04247 11.3274 2.31569 11.2608 2.57559 11.1075L5.80091 9.2483L9.02623 7.38908C10.0991 6.76933 10.0991 5.22331 9.02623 4.61023Z" fill="white" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M6.99967 0.333984C3.31781 0.333984 0.333008 3.31872 0.333008 7.00065C0.333008 10.6826 3.31781 13.6673 6.99967 13.6673C10.6815 13.6673 13.6663 10.6826 13.6663 7.00065C13.6663 3.31872 10.6815 0.333984 6.99967 0.333984ZM6.99967 12.6673C3.87507 12.6673 1.33301 10.1253 1.33301 7.00065C1.33301 3.87598 3.87507 1.33398 6.99967 1.33398C10.1243 1.33398 12.6663 3.87598 12.6663 7.00065C12.6663 10.1253 10.1243 12.6673 6.99967 12.6673Z" fill="white" />
                  <path d="M8.83234 4.50132H5.16701C4.79882 4.50132 4.50034 4.79979 4.50034 5.16798V8.83332C4.50034 9.20151 4.79882 9.49998 5.16701 9.49998H8.83234C9.20053 9.49998 9.49901 9.20151 9.49901 8.83332V5.16798C9.49901 4.79979 9.20053 4.50132 8.83234 4.50132Z" fill="white" />
                </svg> */}
                      </div>
                    </li>}
                  </ul>
                </div>
                <div className={styles.rights}>
                  <VideoSmall participantVideo={participantVideo} videoType={"customer"} />
                </div>
              </div>

              {!remotedev[0]?.video && (
                <div className='novideoname forcustomer'>
                  <div className={styles.flexcontainer}>

                  <div className="novideonametext">{remotedev[0]?.name?.toUpperCase().slice(0, 2)}</div>
                  {vmTransfer === "transfer_initiated" && <div ><p>{`On Hold-${formatTransferTimer(vmTransferTimer)}`}</p></div>}</div>
                </div>
              )}
              <video
                id={remotedev[0]?.conId}
                ref={remVideo}
                playsInline
                autoPlay
                preload={"auto"}
                className={ !annotationEnable ? "videocover" : styles.mainVideo}
                style={{ display: !remotedev.video ? "block" : "none" }}
              />


              <h4 className={styles.username}>{remotedev[0]?.name}</h4>
            </div>
            {customerComponentState === "customerChat" && <div className={styles.videoright} style={{ width: "368px" }}>

              <VideoMeetingChat></VideoMeetingChat>
            </div>}


            {
              (customerComponentState === "customertranscription") && <div className={styles.videoright} style={{ width: "368px" }}>

                <MeetTranscription></MeetTranscription>
              </div>
            }

          </div>
        ) : (<>

          <div className={styles.videosection}>
            <div className={styles.videoshareleft} style={{ width: "368px" }}>
              {


                activeParticipantList.map((elem: any) => {
                  if (!elem.isScreenshare) {
                    return (
                      <VideoShareLeftBar elem={elem} type={"customer"}/>
                    )
                  }
                })
              }

            </div>
            <div className={styles.videoleft} style={{ width: (customerComponentState === "" || (annotationEnable && sharingStatus)) ? "calc(100% - 386px)" : "calc(100% - 744px)",position:"relative"}}>
              <div className={styles.videotopbar}>
                <div className={styles.lefts}>
                  <ul>
                  {/* {!remotedev[0]?.mute ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="8" fill="black" fill-opacity="0.2" />
                        <g clip-path="url(#clip0_3269_55899)">
                          <path d="M16 19.2655C17.7148 19.2655 19.1104 17.87 19.1104 16.1551V9.58475C19.1104 7.86995 17.7149 6.47485 16 6.47485C14.2851 6.47485 12.8901 7.86985 12.8901 9.58475V16.1551C12.8901 17.8699 14.2851 19.2655 16 19.2655ZM14.3901 9.58475C14.3901 8.69705 15.1123 7.97485 16 7.97485C16.8882 7.97485 17.6104 8.69705 17.6104 9.58475V16.1551C17.6104 17.0433 16.8882 17.7655 16 17.7655C15.1123 17.7655 14.3901 17.0433 14.3901 16.1551V9.58475Z" fill="#000" />
                          <path d="M22.4404 16.055V13.0447C22.4404 12.6306 22.1045 12.2947 21.6904 12.2947C21.2763 12.2947 20.9404 12.6306 20.9404 13.0447V16.055C20.9404 18.6629 18.7246 20.785 16 20.785C13.2754 20.785 11.0601 18.6629 11.0601 16.055V13.0447C11.0601 12.6306 10.7242 12.2947 10.3101 12.2947C9.89596 12.2947 9.56006 12.6306 9.56006 13.0447V16.055C9.56006 19.2443 12.0518 21.8779 15.25 22.239V24.2244H11.8301C11.4712 24.2244 11.1802 24.5154 11.1802 24.8748C11.1802 25.2342 11.4712 25.5252 11.8301 25.5252H20.1699C20.5293 25.5252 20.8203 25.2342 20.8203 24.8748C20.8203 24.5154 20.5293 24.2244 20.1699 24.2244H16.75V22.239C19.9483 21.8779 22.4404 19.2442 22.4404 16.055Z" fill="#000" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3269_55899">
                            <rect width="24" height="24" fill="white" transform="translate(4 4)" />
                          </clipPath>
                        </defs>
                      </svg> :


                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="28" height="28" rx="6" fill="black" fill-opacity="0.2" />
                          <g clip-path="url(#clip0_3269_6851)">
                            <path d="M12.39 9.96498L15.61 13.195L16.36 13.955L17.07 14.665C17.1 14.495 17.11 14.325 17.11 14.155V7.58498C17.11 5.86498 15.71 4.47498 14 4.47498C12.28 4.47498 10.89 5.86498 10.89 7.58498V8.45498L11.64 9.20498L12.39 9.96498Z" fill="#DE003D" />
                            <path d="M20.44 14.055V11.045C20.44 10.625 20.1 10.295 19.69 10.295C19.28 10.295 18.94 10.625 18.94 11.045V14.055C18.94 14.775 18.77 15.455 18.46 16.065L19.56 17.175C20.12 16.255 20.44 15.195 20.44 14.055Z" fill="#DE003D" />
                            <path d="M22.68 22.775C22.53 22.925 22.34 22.995 22.15 22.995C21.96 22.995 21.77 22.925 21.62 22.775L17.87 19.015C16.98 19.675 15.92 20.115 14.75 20.245V22.225H18.18C18.54 22.225 18.83 22.515 18.83 22.875C18.83 23.235 18.54 23.525 18.18 23.525H9.83004C9.47004 23.525 9.18004 23.235 9.18004 22.875C9.18004 22.515 9.47004 22.225 9.83004 22.225H13.25V20.245C10.04 19.885 7.55004 17.245 7.55004 14.055V11.045C7.55004 10.625 7.89004 10.295 8.30004 10.295C8.71004 10.295 9.05004 10.625 9.05004 11.045V14.055C9.05004 16.665 11.27 18.785 14 18.785C15.04 18.785 16.01 18.475 16.81 17.945L15.65 16.775C15.17 17.085 14.61 17.255 14 17.255C12.28 17.255 10.89 15.865 10.89 14.155V11.995L5.32004 6.40498C5.03004 6.11498 5.03004 5.63498 5.32004 5.34498C5.61004 5.05498 6.09004 5.05498 6.38004 5.34498L22.68 21.715C22.97 22.005 22.97 22.485 22.68 22.775Z" fill="#DE003D" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3269_6851">
                              <rect x="2" y="2" width="24" height="24" rx="6" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      } */}
                    {!sharingStatus && <li><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M17.7261 0.0126953H13.9263C13.5122 0.0126953 13.1763 0.348595 13.1763 0.762695C13.1763 1.1768 13.5122 1.5127 13.9263 1.5127H17.4151L12.2964 6.6318C12.0034 6.9248 12.0034 7.3994 12.2964 7.6923C12.4429 7.8388 12.6348 7.912 12.8267 7.912C13.0186 7.912 13.2105 7.8388 13.357 7.6923L18.4761 2.5727V6.0624C18.4761 6.4765 18.812 6.8124 19.2261 6.8124C19.6402 6.8124 19.9761 6.4765 19.9761 6.0624V2.2626C19.9761 1.0224 18.9668 0.0126953 17.7261 0.0126953Z" />
                      <path d="M6.64351 12.3076L1.52441 17.4272V13.9375C1.52441 13.5234 1.18851 13.1875 0.774414 13.1875C0.360314 13.1875 0.0244141 13.5234 0.0244141 13.9375V17.7373C0.0244141 18.9775 1.03371 19.9873 2.27441 19.9873H6.07421C6.48831 19.9873 6.82421 19.6514 6.82421 19.2373C6.82421 18.8232 6.48831 18.4873 6.07421 18.4873H2.58541L7.70411 13.3682C7.99711 13.0752 7.99711 12.6006 7.70411 12.3077C7.41111 12.0148 6.93641 12.0146 6.64351 12.3076Z" />
                    </svg></li>}
                  </ul>
                </div>
                <div className={styles.rights} onClick={switchVideoStream}>
                  {/* <VideoSmall participantVideo={participantVideo} /> */}
                </div>
              </div>

              {!remotedev[0]?.video && !sharingStatus && (
                <div className='novideoname forcustomer'>
                  <div className="novideonametext">{remotedev[0]?.name?.toUpperCase().slice(0, 2)}</div>
                  {vmTransfer ==="transfer_initiated" && <div ><p>On Hold<span>{formatTransferTimer(vmTransferTimer)}</span></p></div>}
                </div>
              )}
              <div style={{position:"relative"}}>
              <video
                id={"screenShareVideo"}
                playsInline
                autoPlay
                preload={"auto"}
                className={!annotationEnable ? "videocover"  :styles.mainVideo}
                style={{ display: !remotedev.video ? "block" : "none" ,position:"absolute"}}
                ref={screenShareVideo}
              />
              </div>
              {annotationEnable && <canvas id="canvaagent" style={{position:"absolute"}} onResize={sendScreenSize}></canvas>}


              <h4 className={styles.username}>{remotedev[0]?.name}</h4>
            </div>
            {customerComponentState === "customerChat" && ((!annotationEnable && !sharingStatus) || (!annotationEnable && sharingStatus) || (annotationEnable && !sharingStatus)) && <div className={styles.videoright} style={{ width: "368px" }}>

              <VideoMeetingChat></VideoMeetingChat>
            </div>}
            {customerComponentState ==="customertranscription" && 
             ((!annotationEnable && !sharingStatus) || (!annotationEnable && sharingStatus) || (annotationEnable && !sharingStatus)) && <div className={styles.videoright} style={{ width: "368px" }}>

                <MeetTranscription></MeetTranscription>
              </div>
            }
          </div>


        </>)}
        <div className={styles.videobottom}>
         
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="5" fill="black"/>
<path d="M19.017 6.25574L12.617 3.58874C12.4221 3.50759 12.2131 3.46582 12.002 3.46582C11.7909 3.46582 11.5819 3.50759 11.387 3.58874L4.987 6.25574C4.69496 6.37687 4.44535 6.5818 4.26969 6.84468C4.09403 7.10755 4.00018 7.41657 4 7.73274C4 14.3497 7.817 18.9227 11.383 20.4097C11.578 20.4906 11.7869 20.5322 11.998 20.5322C12.2091 20.5322 12.418 20.4906 12.613 20.4097C15.47 19.2187 20 15.1087 20 7.73274C20.0001 7.41703 19.9069 7.10833 19.732 6.84551C19.5571 6.58268 19.3083 6.37748 19.017 6.25574Z" fill="#00E79F"/>
<path d="M10.4885 9.98438H7.5V12.9727H10.4885V9.98438Z" fill="black"/>
<path d="M16.4999 8.60014V12.9727H13.4772V11.6218C13.4772 10.717 12.7432 9.98295 11.8379 9.98295H10.4873V6.96094H14.8605C15.7658 6.96094 16.4999 7.69496 16.4999 8.60014Z" fill="black"/>
<path d="M13.4768 12.9727V15.9609L10.4883 12.9727H13.4768Z" fill="black"/>
<path d="M13.4772 11.6219V12.9728L10.4873 9.98306H11.8379C12.7432 9.98306 13.4769 10.7167 13.4769 11.6219" fill="#F9FAFB"/>
</svg>

          <div className={styles.centerarea}>
            <ul>

              <li onClick={muteAudio} className={vmTransfer ==="transfer_initiated" ? styles.disabledicon : ""}>
                {currdeviceinfo.mute ?
                  <div className={styles.imageBox}>
                    <div className={styles.imageInn}>
                      <img src={audion} />
                    </div>
                    <div className={styles.hoverImg}>
                      <img src={audioh} />
                    </div>
                  </div>
                  :
                  <div className={styles.imageBox}>
                    <div className={styles.imageInn}>
                      <img src={audioa}></img>
                    </div>
                  </div>
                }
              </li>
              <li onClick={muteVideo} className={vmTransfer ==="transfer_initiated" ? styles.disabledicon : ""}>
                {!currdeviceinfo.video ?
                  <div className={styles.imageBox}>
                    <div className={styles.imageInn}>
                      <img src={videon} />
                    </div>
                    <div className={styles.hoverImg}>
                      <img src={videoh} />
                    </div>
                  </div>
                  :
                  
            <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={videoa}></img>
            </div>
          </div>
          }
              </li>
              <li className={vmTransfer === "transfer_initiated" ? `${styles.disabledicon} ${styles.footerarrow}` : styles.footerarrow}>
                {!ccBtns ? <div className={styles.imageBox}>
                  <div className={styles.imageInn} onClick={startCloseCaption}>
                    <img src={ccn} />
                  </div>
                  <div className={styles.hoverImg} onClick={startCloseCaption} >
                    <img src={cch} />
                  </div>
                  <Popover content={cccontent}
                    trigger="click"
                    overlayClassName="morecochat"
                  >
                    <div className={styles.arrowlink}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
                        <path d="M7.2766 3.93545C7.14833 3.93545 7.02007 3.88665 6.92247 3.78832L4.35347 1.21152C4.25907 1.11712 4.1334 1.06505 3.9996 1.06439C3.8658 1.06439 3.73987 1.11712 3.64513 1.21152L1.0768 3.78832C0.882132 3.98425 0.565065 3.98425 0.369799 3.78965C0.174132 3.59432 0.173532 3.27792 0.368466 3.08265L2.93713 0.505854C3.221 0.22132 3.59827 0.0644531 3.99967 0.0644531C4.40107 0.0651198 4.77833 0.221387 5.06187 0.505854L7.63086 3.08265C7.82586 3.27799 7.8252 3.59439 7.62953 3.78965C7.5322 3.88665 7.4042 3.93545 7.2766 3.93545Z" fill="white" />
                      </svg></div>
                  </Popover>
                </div>
                  :
                  <div className={styles.imageBox}>

                    <img src={cca} onClick={startCloseCaption} />
                    <Popover content={cccontent}
                      trigger="click"
                      overlayClassName="morecochat"
                    >
                      <div className={styles.arrowlink}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
                          <path d="M7.2766 3.93545C7.14833 3.93545 7.02007 3.88665 6.92247 3.78832L4.35347 1.21152C4.25907 1.11712 4.1334 1.06505 3.9996 1.06439C3.8658 1.06439 3.73987 1.11712 3.64513 1.21152L1.0768 3.78832C0.882132 3.98425 0.565065 3.98425 0.369799 3.78965C0.174132 3.59432 0.173532 3.27792 0.368466 3.08265L2.93713 0.505854C3.221 0.22132 3.59827 0.0644531 3.99967 0.0644531C4.40107 0.0651198 4.77833 0.221387 5.06187 0.505854L7.63086 3.08265C7.82586 3.27799 7.8252 3.59439 7.62953 3.78965C7.5322 3.88665 7.4042 3.93545 7.2766 3.93545Z" fill="white" />
                        </svg>
                      </div>
                    </Popover>
                  </div>
                }

              </li>
              <li onClick={meetChat} className={vmTransfer ==="transfer_initiated" ? styles.disabledicon : ""}>
                {customerComponentState !== "customerChat"  && !annotationEnable? <div className={styles.imageBox}>
                  {count > 0 ? <p className={styles.parcount}>{count}</p> : ""}
                  <div className={styles.imageInn}>
                    <img src={chatn} />
                  </div>
                  <div className={styles.hoverImg}>
                    <img src={chath} />
                  </div>
                </div>
                  :
                  annotationEnable ?  
                  <Tooltip title="Message is not available in Co-Browser mode">
                  <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={chatd}></img>
            </div>
          </div>  
          </Tooltip> :
                  
            <div className={styles.imageBox}>
            <div className={styles.imageInn}>
              <img src={chata}></img>
            </div>
          </div>
          }
              </li>
            </ul>
          </div>
          <button onClick={end}>End</button>
        </div>
      </div>
      <Modal open={recordAllowed} title={<><span>Record this meeting?</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={closeRecordModal}> </span>}
        footer={[
          <Button className="buttonCancel" style={{ minWidth: "auto" }}
            onClick={endall}
          >
            Leave Meeting
          </Button>,
          <Button type="primary" className="buttonSave "
            onClick={continueRecording}
          >
            Continue
          </Button>,
        ]}>
        <p>This video meeting is being recorded by the agent. Are you sure want to continue</p>
      </Modal>
      <Modal open={endModal} title={<><span>End Meeting</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={closeEndModal}> </span>}
        footer={[
          <Button className="buttonCancel"
            onClick={closeEndModal}
          >
            Cancel
          </Button>,
          <Button type="primary" className="buttonSave deletebtn"
            onClick={endall}
          >
            Yes, End Meeting
          </Button>,
        ]}>
        <p>Are you sure, you want to end this meeting?</p>
      </Modal>

      <Modal open={annotationPopup} title={<><span>Co-browse access?</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={closeCobrowser}> </span>}
        footer={[
          <Button className="buttonCancel"
            onClick={decline}
          >
            Decline
          </Button>,
          <Button type="primary" className="buttonSave savebtn"
            onClick={accept}
          >
            Accept
          </Button>,
        ]}>
        <p>Are you sure, you want to accept the invite?
        While co-browsing, you will not be able to chat with the agent.</p>
      </Modal>

    </>
  );

};
